module.exports = import("https://tabback.ccbh.com/javascripts/api/tableau.embedding.3.latest.js");;